<template>
	<basic-container>

		<div v-if="mode == '1'">
			<div class="top_flex">
				<div class="top_one img1">
					<img src="../../static/images/wel/top1.png" alt="" class="top_img">
					<div class="top_right">
						<div class="top_number">0</div>
						<div class="top_font">项目量</div>
					</div>
				</div>
				<div class="top_one img2">
					<img src="../../static/images/wel/top2.png" alt="" class="top_img">
					<div class="top_right">
						<div class="top_number">0</div>
						<div class="top_font">服务中</div>
					</div>
				</div>
				<div class="top_one img3">
					<img src="../../static/images/wel/top3.png" alt="" class="top_img">
					<div class="top_right">
						<div class="top_number">0</div>
						<div class="top_font">终止量</div>
					</div>
				</div>
				<div class="top_one img4">
					<img src="../../static/images/wel/top4.J.png" alt="" class="top_img">
					<div class="top_right">
						<div class="top_number">0</div>
						<div class="top_font">执行机构数</div>
					</div>
				</div>

				<div class="top_one img6">
					<img src="../../static/images/wel/top6.F.png" alt="" class="top_img">
					<div class="top_right">
						<div class="top_number">0</div>
						<div class="top_font">总费用</div>
					</div>
				</div>
			</div>
			<avue-crud :option="informationOption" :table-loading="loading" :data="data" ref="crud" v-model="form"
				@row-del="rowDel" :search.sync="search" @row-update="rowUpdate" @row-save="rowSave" :page="page"
				:permission="permissionList" @search-change="searchChange" @search-reset="searchReset"
				@selection-change="selectionChange" @current-change="currentChange" @size-change="sizeChange"
				@refresh-change="refreshChange" @on-load="onLoad">
				<template slot-scope="scope" slot="menu">
					<!-- <el-button type="text"
                     icon="el-icon-view"
                     size="small"
                     @click.stop="viewArchives(scope.row, scope.index)">查 看
          </el-button>
          <el-button type="text"
                     icon="el-icon-edit"
                     size="small"
                     @click.stop="copyUser(scope.row, scope.index)">编 辑
          </el-button> -->
					<el-button type="text" icon="el-icon-document-add" size="small"
						@click.stop="copyUser(scope.row, scope.index)">打 印
					</el-button>
				</template>
				<template slot="menuLeft">
					<!-- <el-button type="primary"
                     size="small"
                     icon="el-icon-plus"
                     @click="$router.push({path: '/project/detail',query: {state: 1}})">新 增
          </el-button> -->
					<el-button type="danger" size="small" plain icon="el-icon-delete" @click="handleDelete">删 除
					</el-button>
					<el-button type="success" size="small" plain icon="el-icon-upload2" @click="handleImport">导 入
					</el-button>
					<el-button type="warning" size="small" plain icon="el-icon-download" @click="handleExport">导 出
					</el-button>
				</template>
				<template slot="goodsDetail4">
					<el-tag @click="showRecord">快速跟踪</el-tag>
				</template>
			</avue-crud>

		</div>
		<div v-if="mode == '2'">
			<div class="top_flex">
				<div class="top_one img1">
					<img src="../../static/images/wel/top1.png" alt="" class="top_img">
					<div class="top_right">
						<div class="top_number">0</div>
						<div class="top_font">档案量</div>
					</div>
				</div>
				<div class="top_one img2">
					<img src="../../static/images/wel/top2.png" alt="" class="top_img">
					<div class="top_right">
						<div class="top_number">0</div>
						<div class="top_font">服务中</div>
					</div>
				</div>
				<div class="top_one img3">
					<img src="../../static/images/wel/top3.png" alt="" class="top_img">
					<div class="top_right">
						<div class="top_number">0</div>
						<div class="top_font">终止量</div>
					</div>
				</div>
				<div class="top_one img4">
					<img src="../../static/images/wel/top4.png" alt="" class="top_img">
					<div class="top_right">
						<div class="top_number">0</div>
						<div class="top_font">困境老人</div>
					</div>
				</div>
				<div class="top_one img5">
					<img src="../../static/images/wel/top5.png" alt="" class="top_img">
					<div class="top_right">
						<div class="top_number">0</div>
						<div class="top_font">留守老人</div>
					</div>
				</div>
				<div class="top_one img6">
					<img src="../../static/images/wel/top6.png" alt="" class="top_img">
					<div class="top_right">
						<div class="top_number">0</div>
						<div class="top_font">跟踪量</div>
					</div>
				</div>
			</div>
			<avue-crud :option="option" :table-loading="loading" :data="data" ref="crud" v-model="form"
				@row-del="rowDel" :search.sync="search" @row-update="rowUpdate" @row-save="rowSave" :page="page"
				:permission="permissionList" @search-change="searchChange" @search-reset="searchReset"
				@selection-change="selectionChange" @current-change="currentChange" @size-change="sizeChange"
				@refresh-change="refreshChange" @on-load="onLoad">
				<template slot-scope="scope" slot="menu">
					<el-button type="text" icon="el-icon-document-add" size="small"
						@click.stop="copyUser(scope.row, scope.index)">打印
					</el-button>
				</template>
				<template slot="menuLeft">
					<el-button type="primary" size="small" icon="el-icon-plus"
						@click="$router.push({path: '/project/detail',query: {state: 1}})">新 增
					</el-button>
					<el-button type="danger" size="small" plain icon="el-icon-delete" @click="handleDelete">删 除
					</el-button>
					<el-button type="success" size="small" plain icon="el-icon-upload2" @click="handleImport">导 入
					</el-button>
					<el-button type="warning" size="small" plain icon="el-icon-download" @click="handleExport">导 出
					</el-button>
				</template>
			</avue-crud>
		</div>

		<el-dialog title="跟踪服务记录" append-to-body :visible.sync="addfollowUpVisit" width="555px"
			custom-class="common-dialog">
			<el-timeline :reverse="reverse">
				<el-timeline-item v-for="(item,index) in followUpList" :key="index"
					:timestamp="`${item.createUserName} ${item.visitTime}`">
					{{item.content}}
				</el-timeline-item>
			</el-timeline>
			<avue-form :option="addfollowUpOption" v-model="addfollowUpForm" ref="addfollowUpForm"
				@submit="addFollowHandle"></avue-form>
		</el-dialog>
	</basic-container>
</template>
<script>
	import {
		getList,
		remove,
		update,
		add,
	} from "@/api/order/index";
	import {
		mapGetters
	} from "vuex";

	export default {
		data() {
			return {
				mode: "1",
				form: {},
				search: {},
				query: {},
				// 加载
				loading: true,
				// 分页
				page: {
					pageSize: 10,
					currentPage: 1,
					total: 0,
				},
				// 数据
				data: [],
				// 配置
				option: {
					height: "auto",
					searchShow: true,
					searchMenuSpan: 6,
					tip: false,
					border: true,
					index: true,
					selection: true,
					viewBtn: false,
					addBtn: false,
					delBtn: false,
					editBtn: false,
					column: [{
							label: "关键词搜索",
							prop: "keyword",
							search: true, //是否搜索
							hide: true, // 是否显示列
							addDisplay: false, // 新增字段显示隐藏
							editDisplay: false, // 修改字段显示隐藏
							viewDisplay: false, // 查看字段显示隐藏
							searchLabelWidth: 100, // 搜索文字宽度
							searchMenuSpan: 6, // 搜索宽度
							showColumn: false, //
						},
						{
							label: "立项编号",
							prop: "orderNo",
							width: 160,
						},
						{
							label: "项目编号",
							prop: "orderNo",
							width: 160,
						},
						{
							label: "类型",
							prop: "cardNo",
						},

						{
							label: "区域",
							prop: "goodsDetail",
						},
						{
							label: "项目执行费用",
							prop: "goodsDetail",
						},
						{
							label: "发起机构",
							prop: "goodsDetail",
						},
						{
							label: "执行机构",
							prop: "goodsDetail",
						},
						{
							label: "执行时间段",
							prop: "goodsDetail",
						},
						{
							label: "项目状态",
							prop: "goodsDetail",
						},
					],
				},
				reverse: false,
				activities: [],
				dialogVisible: false,
				dialogFormVisible: false,
				deliverForm: {},
				orderObj: {},
				orderSearch: {},
				valueAbc: "",
				addfollowUpVisit: false,
				addfollowUpForm: {},
				addfollowUpOption: {
					column: [{
							label: '单据号',
							labelPosition: 'top',
							prop: 'content',
							placeholder: '系统自动生成',
							readonly: true,
							row: true,
							span: 24
						},
						{
							label: '时间',
							labelPosition: 'top',
							prop: 'visitTime',
							type: "datetime",
							format: "yyyy-MM-dd hh:mm:ss",
							valueFormat: "yyyy-MM-dd hh:mm:ss",
							row: true,
							span: 24
						}, {
							label: '跟踪服务类型',
							labelPosition: 'top',
							prop: 'interviewType',
							type: "select",
							dicUrl: "/api/blade-system/dict-biz/dictionary",
							dicQuery: {
								code: 'visit-tracking_method'
							},
							props: {
								label: "dictValue",
								value: "dictKey"
							},
							row: true,
							span: 24
						}, {
							label: '跟踪情况描述',
							labelPosition: 'top',
							prop: 'content',
							type: "textarea",
							row: true,
							span: 24,

						},
						{
							label: "上传文件",
							labelPosition: 'top',
							prop: "imgUrls",
							type: 'upload',
							listType: 'picture-img',
							dataType: 'array',
							loadText: '文件上传中，请稍等',
							tip: '只能上传png/jpg图片，且不超过2MB',
							action: '/api/blade-resource/oss/endpoint/put-file-attach',
							propsHttp: {
								res: 'data',
								url: 'link'
							},
							data: {
								fileName: 'imgUrls'
							},
							span: 24,
							hide: true
						}, {
							label: '服务机构名称',
							labelPosition: 'top',
							prop: 'content123',
							row: true,
							span: 24,
							type: 'select',
							disabled: this.$store.state.user.userInfo.account === 'admin' ? false : true,
							dicUrl: "/api/blade-system/dept/tree",
							props: {
								label: 'title',
								value: "value"
							},
							value: this.$store.state.user.userInfo.dept_id,
							dataType: 'string',
						}, {
							label: '经办人',
							labelPosition: 'top',
							prop: 'content',
							row: true,
							span: 24
						},
					],
				},
				informationOption: {
					border: true,
					index: true,
					calcHeight: 100,
					labelWidth: '120',
					column: [{
							label: "项目名称",
							prop: "tenantId",
							span: 12,
							placeholder: '请输入 项目名称',
							rules: [{
								required: true,
								message: "请输入 项目名称",
								trigger: "blur"
							}]
						},
						{
							label: "立项时间",
							prop: "datetime12",
							type: "datetime",
							placeholder: '请选择 时间',
							span: 12,
							rules: [{
								required: true,
								message: "请选择 时间",
								trigger: "blur"
							}]
						},
						{
							label: "立项编号",
							prop: "tenantId",
							placeholder: '请输入 立项编号',
							span: 12,
							readonly: true,
							rules: [{
								required: true,
								message: "请输入 立项编号",
								trigger: "blur"
							}]
						},
						{
							label: "项目编号",
							prop: "tenantId",
							placeholder: '请输入 项目编号',
							span: 12,
							readonly: true,
							rules: [{
								required: true,
								message: "请输入 项目编号",
								trigger: "blur"
							}]
						},
						{
							label: "项目类型",
							prop: "tenantId",
							placeholder: '请选择 项目类型',
							span: 12,
							readonly: true,
							rules: [{
								required: true,
								message: "请选择 项目类型",
								trigger: "blur"
							}]
						},
						{
							label: "项目执行费用",
							prop: "tenantId",
							placeholder: '请输入 项目执行费用',
							span: 12,
							readonly: true,
							rules: [{
								required: true,
								message: "请输入 项目执行费用",
								trigger: "blur"
							}]
						},
						{
							label: "计划类型",
							prop: "tenantId",
							placeholder: '请选择 计划类型',
							span: 12,
							readonly: true,
							rules: [{
								required: true,
								message: "请选择 计划类型",
								trigger: "blur"
							}]
						},
						// {
						// 	label: "统一信用代码",
						// 	prop: "tenantId",
						// 	placeholder: '请输入 统一信用代码',
						// 	span: 12,
						// 	readonly: true,
						// 	rules: [{
						// 		required: true,
						// 		message: "请输入 统一信用代码",
						// 		trigger: "blur"
						// 	}]
						// },
						{
							label: "签约状态",
							prop: "tenantId",
							placeholder: '请选择 签约状态',
							span: 12,
							readonly: true,
							rules: [{
								required: true,
								message: "请选择 签约状态",
								trigger: "blur"
							}]
						},
						{
							label: "联系人",
							prop: "tenantId",
							placeholder: '请输入 联系人',
							span: 12,
							readonly: true,
							rules: [{
								required: true,
								message: "请输入 联系人",
								trigger: "blur"
							}]
						},
						{
							label: "执行机构",
							prop: "tenantId",
							placeholder: '请选择 执行机构',
							span: 12,
							readonly: true,
							rules: [{
								required: true,
								message: "请选择 执行机构",
								trigger: "blur"
							}]
						},
						{
							label: "联系电话",
							prop: "tenantId",
							placeholder: '请输入 联系电话',
							span: 12,
							readonly: true,
							rules: [{
								required: true,
								message: "请输入 联系电话",
								trigger: "blur"
							}]
						},
						// {
						// 	label: "结对编号",
						// 	prop: "tenantId",
						// 	placeholder: '系统自动生成',
						// 	span: 12,
						// 	readonly: true,
						// 	rules: [{
						// 		required: true,
						// 		message: "请输入单据号",
						// 		trigger: "blur"
						// 	}]
						// },
						// {
						// 	label: "结对类型",
						// 	prop: "tenantId",
						// 	placeholder: '请选择 结对类型',
						// 	span: 12,
						// 	readonly: true,
						// 	rules: [{
						// 		required: true,
						// 		message: "请选择 结对类型",
						// 		trigger: "blur"
						// 	}]
						// },
						{
							label: "发起机构",
							prop: "tenantId",
							placeholder: '请选择 发起机构',
							span: 12,
							readonly: true,
							rules: [{
								required: true,
								message: "请选择 发起机构",
								trigger: "blur"
							}]
						},
						{
          label: "项目介绍附件",
          prop: "voucherUrl",
          type: 'upload',
          dataType: 'array',
          loadText: '项目介绍附件上传中，请稍等',
          tip: '只能上传PDF版项目介绍附件文件，且不超过2MB',
          action: '/api/blade-resource/oss/endpoint/put-file',
          propsHttp: {
            res: 'data',
            url: 'link',
          },
          rules: [{
            required: true,
            message: "请上传项目介绍附件",
            trigger: "blur"
          }],
          data: {
            fileName: 'voucherUrl'
          },
          uploadBefore: (file, done, loading) => {
            var FileExt = file.name.replace(/.+\./, "");
            if (['pdf'].indexOf(FileExt.toLowerCase()) === -1) {
              this.$message({
                type: 'warning',
                message: '请上传后缀名为PDF的附件！'
              });
              loading();
            } else {
              this.isLt2k = file.size / (1024 * 1024) < 2;
              if (!this.isLt2k) {
                this.$message({
                  message: '上传文件大小不能超过2MB!',
                  type: 'error'
                });
                loading();
              } else {
                done()
              }
            }
          },
          uploadPreview: (file, column, done) => {
            this.pdfSrc = file.url
            this.OnlinelVisible = true
          },
          span: 24,
          hide: true
        },
						// {
						// 	label: "上传图片",
						// 	width: "100px",
						// 	// labelPosition: 'left',
						// 	prop: "imgUrls",
						// 	type: 'upload',
						// 	dataType: 'array',
						// 	listType: 'picture-card',
						// 	loadText: '图片上传中，请稍等',
						// 	tip: '只能上传jpg/png/pdf凭证图片，且不超过2MB',
					 // 	action: '/api/blade-resource/oss/endpoint/put-file-attach',
						// 	propsHttp: {
						// 		res: 'data',
						// 		url: 'link'
						// 	},
						// 	data: {
						// 		fileName: 'imgUrls'
						// 	},
						// 	span: 12,
						// 	hide: true
						// },
						{
							label: "项目介绍",
							prop: "textData",
							placeholder: '请填写 项目介绍',
							component: 'AvueUeditor',
							span: 24,
							hide: true,
							readonly: true,
							rules: [{
								required: true,
								message: "请填写 说明",
								trigger: "blur"
							}]
						},
					]
				},
			};
		},

		computed: {
			...mapGetters(["permission"]),
			permissionList() {
				return {
					// set_print_dept: this.vaildData(this.permission.set_print_dept, false),
					// update_print_status: this.vaildData(
					//   this.permission.update_print_status,
					//   false
					// ),
				};
			},
			ids() {
				let ids = [];
				this.selectionList.forEach((ele) => {
					ids.push(ele.id);
				});
				return ids.join(",");
			},
		},
		mounted() {
			console.log(this.$store.state.user.userInfo.dept_id)
		},
		methods: {
			viewArchives() {
				this.$router.push({
					path: '/project/detail',
					query: {
						state: 2
					}
				})
			},
			showRecord() {
				this.addfollowUpVisit = true
			},
			chanceGroup(e) {
				this.mode = e;
			},
			handleClose() {
				this.$refs["ruleForm"].resetFields();
				this.dialogFormVisible = false;
			},
			// 复制收货人信息
			copyUser(row) {
				this.$Clipboard({
						text: `领取人：${row.consigneeName}，联系方式：${row.receivePhone}，收货地址：${row.receiveProvince}${row.receiveCity}${row.receiveCounty}${row.receiveAddress}`,
					})
					.then(() => {
						this.$message.success("复制成功");
					})
					.catch(() => {
						this.$message.error("复制失败");
					});
			},
			// 搜索
			searchChange(params, done) {
				this.query = params;
				this.page.currentPage = 1;
				this.onLoad(this.page, params);
				done();
			},
			selectionChange(list) {
				this.selectionList = list;
			},
			// 新增
			rowSave(row, done, loading) {
				add(row).then(
					() => {
						done();
						this.onLoad(this.page);
						this.$message({
							type: "success",
							message: "操作成功!",
						});
					},
					(error) => {
						window.console.log(error);
						loading();
					}
				);
			},
			// 修改
			rowUpdate(row, index, done, loading) {
				update(row).then(
					() => {
						done();
						this.onLoad(this.page);
						this.$message({
							type: "success",
							message: "操作成功!",
						});
					},
					(error) => {
						window.console.log(error);
						loading();
					}
				);
			},
			// 删除
			rowDel(row) {
				this.$confirm("确定将选择数据删除?", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						return remove(row.id);
					})
					.then(() => {
						this.onLoad(this.page);
						this.$message({
							type: "success",
							message: "操作成功!",
						});
					});
			},
			// 清空
			searchReset() {
				this.query = {};
				this.$route.query.id = "";
				this.onLoad(this.page);
			},
			// 页面跳转
			currentChange(currentPage) {
				this.page.currentPage = currentPage;
			},
			// 更改分页数
			sizeChange(pageSize) {
				this.page.pageSize = pageSize;
			},
			// 刷新
			refreshChange() {
				this.onLoad(this.page, this.query);
			},
			// 装载
			onLoad(page, params = {}) {
				this.loading = true;
				getList(
					page.currentPage,
					page.pageSize,
					Object.assign(params, this.query)
				).then((res) => {
					const data = res.data.data;
					this.page.total = data.total;
					this.data = data.records;
					this.loading = false;
				});
			},
		},
	};
</script>
<style scoped lang='scss'>
	.top_title {
		font-size: 22px;
		font-family: PingFang-SC-Bold, PingFang-SC;
		font-weight: bold;
		color: #232428;
		margin-bottom: 24px;
		display: flex;
		flex-flow: row nowrap;
		justify-content: flex-start;
		align-items: center;

		.right {
			margin-left: 30px;
		}
	}

	.top_flex {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 20px 0;
	}

	.top_one {
		flex: 1;
		margin: 6px;
		height: 112px;
		display: flex;
		box-sizing: border-box;
		align-items: center;
		padding: 0 30px;
	}

	.top_right {
		display: flex;
		flex-direction: column;
	}

	.top_number {
		font-size: 36px;
		font-family: DINPro-Bold, DINPro;
		font-weight: bold;
		color: #111111;
	}

	.top_font {
		font-size: 14px;
		font-family: PingFang-SC-Regular, PingFang-SC;
		font-weight: 400;
		color: #111111;
	}

	.top_img {
		// width: 40%; -->
		// height: 80%;
		width: 80px;
		// height: 80px;
		margin-right: 10%;
	}

	.img1 {
		background-color: #e2f3f5;
		border-radius: 16px;
	}

	.img2 {
		background-color: #fde7e7;
		border-radius: 16px;
	}

	.img3 {
		background-color: #e2efff;
		border-radius: 16px;
	}

	.img4 {
		background-color: #CEDAFF;
		border-radius: 16px;
	}

	.img5 {
		background-color: #f5e6fe;
		border-radius: 16px;
	}

	.img6 {
		background-color: #FFF3D8;
		border-radius: 16px;
	}
</style>
